import { ColumnType, Handle } from "./Table";
export { default } from "./Table";

export type Column = ColumnType;
export type TableHandle = Handle;
